import {
  consentsResponseSchema,
  recordConsentRequestSchema,
  type RecordConsentRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

// Consent audit trail (LEGAL-03). ORDER_CONFIRM is written server-side inside the
// order transaction (LEGAL-04), so it does NOT go through recordConsent here;
// these endpoints power the standalone grant/withdraw + privacy screen (LEGAL-12).
export function createConsentsResource(ctx: RequestContext) {
  return {
    // Grant or withdraw a purpose. Server fills docVersion/ip/ua/source.
    recordConsent(body: RecordConsentRequest) {
      const payload = recordConsentRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/me/consents`,
        body: payload,
        dataSchema: consentsResponseSchema,
        auth: true,
      });
    },
    // Current state per purpose + full history.
    listConsents() {
      return requestJson(ctx, {
        method: "GET",
        path: `/me/consents`,
        dataSchema: consentsResponseSchema,
        auth: true,
      });
    },
  };
}
